import { ref } from "vue";
import { defineStore } from "pinia";

// PQ : Price Quote
const usePQStore = defineStore("price-quotes", () => {
  //* States

  const shouldPerformQueryListPq = ref(false);


  const pq = ref({});
  const selectedClientData = ref({});
  const pqForm = ref({
    loaded: false,
    pqInfo: {
      visita_id: "",
      cliente: {
        key: "",
        value: "",
      },
      tipo: {
        key: "",
        type: "",
      },
      bodega: {
        key: "",
        type: "",
      },
      vendedor: {
        key: "",
        value: "",
      },
      codigos_vendedor: {
        key: "",
        value: "",
      },
      fecha: "",
      fecha_despacho: "",
      estado: "Cotizado",
      observaciones_generales:'',
      observaciones_despacho:'',
      horario_recepcion:'',
      condiciones_despacho:'',
      atencion_a:'',
      valor_flete:undefined,
      condicion_pago:undefined,
      forma_pago:undefined,

      direccion: "",
      ciudad: "",       // TODO: CREATE NEW MIGRATION ON API TO ADD THIS FIELD ON PEDIDO TABLE
    },
    visit: {
      latitud: 0,
      longitud: 0,
      resultado: "Se concreta Visita",
      comentarios: "",
    },
    payment: {
      forma_pago: "",
      moneda: "CLP",
      condicion_pago: "",
      amount: "",
    },
    products: [],
    direccion: [],
    perfil_financiero: {}
  });

  const pageMeta = ref({
    current_page: 1,
    first_page_url: "",
    from: 1,
    last_page: 1,
    last_page_url: "",
    links: [],
  });

  //* Methods

  const resetPQForm = () => {
    pqForm.value = {
    id: null, // <--- IMPORTANTE: Agregamos el ID
    loaded: false,
    firstTimeProducts: true,
    pqInfo: {
      visita_id: "",
      cliente: { key: "", value: "" },
      tipo: { key: "", value: "" }, // Antes decía 'type'
      bodega: { key: "", value: "" }, // Antes decía 'type'
      vendedor: { key: "", value: "" },
      codigos_vendedor: { key: "", value: "" },
      moneda: { key: "", value: "" },
      fecha: "",
      fecha_despacho: "",
      direccion: "",
      ciudad: "",
      estado: "Cotizado",
      
      // Inicializamos como objetos vacíos para que AppSelect no explote
      condicion_pago: { key: null, value: "" },
      forma_pago: { key: null, value: "" },
      
      observaciones_generales: '',
      observaciones_despacho: '',
      horario_recepcion: '',
      condiciones_despacho: '',
      atencion_a: '',
      valor_flete: 0,
    },
    products: [],
    visit: { latitud: 0, longitud: 0, resultado: "", comentarios: "" },
  };
  };

  //* Actions
  const prevPage = () => {
    if (pageMeta.value.current_page > 1) {
      --pageMeta.value.current_page;
      executePerformQueryListPq();
    }
  };
  const nextPage = () => {
    if (pageMeta.value.current_page < pageMeta.value.last_page){
      ++pageMeta.value.current_page;
      executePerformQueryListPq();
    }
  };

  const resetPerformQueryListPq   = () => shouldPerformQueryListPq.value = false;
  const executePerformQueryListPq = () => shouldPerformQueryListPq.value = true;

  return {
    //* States
    shouldPerformQueryListPq,


    pq,
    pqForm,
    selectedClientData,

    pageMeta,

    //* Actions
    setPQ: (newPQ) => (pq.value = { ...newPQ }),
    setPQForm: (newPQForm) => {
      pqForm.value = null;
      pqForm.value = JSON.parse(JSON.stringify(newPQForm));
    },
    resetPQ: () => (pq.value = {}),
    resetPQForm,

    setPageMeta: (newMeta) => (pageMeta.value = { ...newMeta }),
    setCurrentPage: (newPage) => (pageMeta.value.current_page = newPage),

    setProductsPageMeta: (newMeta) =>
      (pqProductsPageMeta.value = { ...newMeta }),
    setProductsCurrentPage: (newPage) =>{
      pqProductsPageMeta.value.current_page = newPage
      executePerformQueryListPq();
    },
    
    prevPage,
    nextPage,

    executePerformQueryListPq,
    resetPerformQueryListPq,

   
  };
});

export default usePQStore;
